import {
  portalOrdersDe,
  portalOrdersEn,
  portalOrdersEs,
  portalOrdersFr,
  portalOrdersRu,
  portalOrdersTr,
} from './portal-orders-i18n';

export const portalDe = {
  ...portalOrdersDe,
  brand: 'Kundenportal',
  featureDisabled: {
    title: 'Bereich nicht verfügbar',
    description: 'Dieser Portalbereich ist für Ihr Unternehmen derzeit deaktiviert.',
  },
  welcome: 'Willkommen, {{name}}',
  accountSubtitle: 'Ihr sicherer Zugang zu {{customer}}.',
  login: {
    title: 'Am Kundenportal anmelden',
    subtitle: 'Zugang nur nach persönlicher Einladung.',
    tenant: 'Mandant',
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    submit: 'Anmelden',
    forgot: 'Passwort vergessen?',
    genericError: 'E-Mail-Adresse oder Passwort ist falsch.',
    twoFactor: 'Bestätigungscode',
    codeSent: 'Ein Code wurde an {{email}} gesendet.',
    verify: 'Code bestätigen',
  },
  invitation: {
    title: 'Portalzugang aktivieren',
    subtitle: 'Einladung von {{customer}} für {{contact}}.',
    password: 'Passwort festlegen',
    passwordRules: 'Mindestens 12 Zeichen mit Groß- und Kleinbuchstaben, Zahl und Sonderzeichen.',
    confirmation: 'Passwort wiederholen',
    accept: 'Zugang aktivieren',
    accepted: 'Der Zugang wurde aktiviert. Sie können sich jetzt anmelden.',
    invalid: 'Diese Einladung ist ungültig, abgelaufen oder wurde bereits verwendet.',
  },
  reset: {
    title: 'Passwort zurücksetzen',
    subtitle: 'Sie erhalten einen Einmal-Link, sofern ein passender Zugang besteht.',
    request: 'Link anfordern',
    sent: 'Wenn ein passender Zugang besteht, wurde eine E-Mail versandt.',
    complete: 'Neues Passwort speichern',
    completed: 'Das Passwort wurde geändert. Alle bisherigen Sitzungen wurden beendet.',
    invalid: 'Der Link ist ungültig, abgelaufen oder wurde bereits verwendet.',
  },
  nav: {
    dashboard: 'Übersicht',
    documents: 'Belege',
    dunning: 'Mahnungen',
    files: 'Dateien',
    account: 'Konto & Sicherheit',
    team: 'Portalbenutzer',
    catalog: 'Katalog',
    cart: 'Warenkorb',
    logout: 'Abmelden',
  },
  dashboard: {
    title: 'Übersicht',
    subtitle: 'Aktuelle Vorgänge und offene Rechnungen auf einen Blick.',
    openInvoices: 'Offene Rechnungen',
    recentDocuments: 'Aktuelle Belege',
    recentDunning: 'Aktuelle Mahnungen',
    showAll: 'Alle anzeigen',
    error: 'Die Übersicht konnte nicht geladen werden.',
  },
  documents: {
    title: 'Belege',
    subtitle: 'Angebote, Aufträge, Lieferungen, Rechnungen und Gutschriften.',
    search: 'Belege durchsuchen',
    searchPlaceholder: 'Belegnummer oder Referenz …',
    typeFilter: 'Belegart filtern',
    allTypes: 'Alle Belegarten',
    empty: 'Keine passenden Belege vorhanden.',
    error: 'Die Belege konnten nicht geladen werden.',
    details: 'Details',
    back: 'Zurück zu den Belegen',
    notFound: 'Der Beleg wurde nicht gefunden oder ist nicht freigegeben.',
    preview: 'PDF öffnen',
    download: 'Herunterladen',
    downloadError: 'Die Datei konnte nicht heruntergeladen werden.',
    date: 'Belegdatum',
    due: 'Fällig',
    total: 'Gesamt',
    open: 'Offen',
    net: 'Netto',
    tax: 'Umsatzsteuer',
    billingAddress: 'Rechnungsadresse',
    shippingAddress: 'Lieferadresse',
    positions: 'Positionen',
    article: 'Artikelnummer',
    description: 'Bezeichnung',
    quantity: 'Menge',
    unitPrice: 'Einzelpreis',
    flow: 'Belegfluss',
    customerData: 'Kundendaten zum Beleg',
  },
  dunning: {
    title: 'Mahnungen',
    subtitle: 'Freigegebene und versendete Mahnungen mit zugehörigen Rechnungen.',
    level: 'Mahnstufe {{level}}',
    totalDue: 'Gesamtforderung',
    principal: 'Offene Posten',
    fees: 'Gebühren',
    interest: 'Zinsen',
    invoices: 'Enthaltene Rechnungen',
    invoice: 'Rechnung',
    empty: 'Keine Mahnungen vorhanden.',
    error: 'Die Mahnungen konnten nicht geladen werden.',
    notFound: 'Die Mahnung wurde nicht gefunden oder ist nicht freigegeben.',
    back: 'Zurück zu den Mahnungen',
  },
  files: {
    title: 'Dokumente & Dateien',
    subtitle: 'Vom Unternehmen ausdrücklich für Sie freigegebene Dateien.',
    attachments: 'Freigegebene Anhänge',
    search: 'Dateien durchsuchen',
    searchPlaceholder: 'Dateiname oder Titel …',
    empty: 'Keine freigegebenen Dateien vorhanden.',
    error: 'Die Dateien konnten nicht geladen werden.',
  },
  pagination: {
    label: 'Seitennavigation',
    previous: 'Zurück',
    next: 'Weiter',
    page: 'Seite {{page}} von {{total}}',
  },
  sessions: {
    title: 'Aktive Sitzungen',
    current: 'Dieses Gerät',
    revoke: 'Sitzung beenden',
    revokeAll: 'Von allen Geräten abmelden',
    empty: 'Keine aktive Sitzung gefunden.',
    browser: 'Browser',
  },
  team: {
    title: 'Portalbenutzer',
    subtitle: 'Zugänge dieses Kunden verwalten.',
    invite: 'Benutzer einladen',
    contact: 'Ansprechpartner',
    role: 'Portalrolle',
    users: 'Aktive Zugänge',
    invitations: 'Einladungen',
    noUsers: 'Noch keine Portalzugänge.',
    noInvitations: 'Noch keine Einladungen.',
    twoFactor: 'E-Mail-2FA',
    lastLogin: 'Letzte Anmeldung',
    activeSessions: 'Aktive Sitzungen',
    active: 'Aktiv',
    locked: 'Gesperrt',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    pending: 'Ausstehend',
    expired: 'Abgelaufen',
    accepted: 'Angenommen',
    revoked: 'Widerrufen',
    lockReason: 'Durch den Kundenadministrator gesperrt',
    revokeReason: 'Durch den Kundenadministrator widerrufen',
  },
  internal: {
    title: 'Kundenportal',
    subtitle: 'Einladungen, Rollen, Sperren und Sitzungen dieses Kunden.',
    required2fa: 'E-Mail-2FA für alle Portalbenutzer erzwingen',
    invitationHours: 'Gültigkeit der Einladung (Stunden)',
    retentionDays: 'Aufbewahrung der Portalaktivitäten (Tage)',
    access: 'Portalzugänge',
    settings: 'Sicherheit & Aufbewahrung',
    noContacts: 'Es ist kein verfügbarer Ansprechpartner mit E-Mail-Adresse vorhanden.',
    lockReason: 'Durch einen internen Benutzer gesperrt',
    revokeReason: 'Durch einen internen Benutzer widerrufen',
    settingsHint: 'Diese Einstellungen gelten mandantenweit für das Kundenportal.',
  },
  activity: {
    title: 'Portal-Aktivitätsprotokoll',
    noEntries: 'Noch keine Portalaktivitäten.',
    system: 'System',
    event: {
      LOGIN_SUCCESS: 'Erfolgreiche Anmeldung',
      LOGIN_FAILED: 'Fehlgeschlagene Anmeldung',
      LOGOUT: 'Abmeldung',
      INVITATION_CREATED: 'Einladung erstellt',
      INVITATION_RESENT: 'Einladung erneut gesendet',
      INVITATION_REVOKED: 'Einladung widerrufen',
      INVITATION_ACCEPTED: 'Einladung angenommen',
      USER_LOCKED: 'Portalzugang gesperrt',
      USER_UNLOCKED: 'Portalzugang entsperrt',
      SESSION_REVOKED: 'Sitzung beendet',
      PASSWORD_RESET_REQUESTED: 'Passwort-Reset angefordert',
      PASSWORD_RESET_COMPLETED: 'Passwort geändert',
      TWO_FACTOR_CHALLENGE: '2FA-Code angefordert',
      TWO_FACTOR_VERIFIED: '2FA bestätigt',
      TWO_FACTOR_FAILED: '2FA fehlgeschlagen',
      PROFILE_CHANGED: 'Profil geändert',
      DOCUMENT_OPENED: 'Dokument geöffnet',
      DOCUMENT_DOWNLOADED: 'Dokument heruntergeladen',
      QUOTE_VIEWED: 'Angebot angesehen',
      ORDER_CREATED: 'Bestellung erstellt',
      ORDER_SUBMITTED: 'Bestellung abgesendet',
      ACTION_FAILED: 'Portalaktion fehlgeschlagen',
      ERROR_DISPLAYED: 'Fehlermeldung angezeigt',
      DELIVERY_ADDRESS_CHANGED: 'Lieferadresse geändert',
    },
  },
  role: { ADMIN: 'Administrator', PURCHASING: 'Einkauf', READ_ONLY: 'Nur Lesen' },
  actions: {
    invite: 'Einladung senden',
    resend: 'Erneut senden',
    revoke: 'Widerrufen',
    lock: 'Sperren',
    unlock: 'Entsperren',
    sessions: 'Alle Sitzungen beenden',
    save: 'Speichern',
  },
  saved: 'Änderungen gespeichert.',
  help: 'Hilfe zum Kundenportal',
  backToLogin: 'Zur Anmeldung',
  select: 'Bitte auswählen',
  unavailableContact: 'Bereits eingeladen oder freigeschaltet',
  securityNotice: 'Zugangsdaten und Einmal-Links werden niemals im Protokoll gespeichert.',
  error: 'Die Aktion konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
} as const;

export const portalEn = {
  ...portalOrdersEn,
  brand: 'Customer portal',
  featureDisabled: {
    title: 'Area unavailable',
    description: 'This portal area is currently disabled for your organisation.',
  },
  welcome: 'Welcome, {{name}}',
  accountSubtitle: 'Your secure access to {{customer}}.',
  login: {
    title: 'Sign in to the customer portal',
    subtitle: 'Access is available by personal invitation only.',
    tenant: 'Tenant',
    email: 'Email address',
    password: 'Password',
    submit: 'Sign in',
    forgot: 'Forgot password?',
    genericError: 'Email address or password is incorrect.',
    twoFactor: 'Verification code',
    codeSent: 'A code was sent to {{email}}.',
    verify: 'Verify code',
  },
  invitation: {
    title: 'Activate portal access',
    subtitle: 'Invitation from {{customer}} for {{contact}}.',
    password: 'Set password',
    passwordRules:
      'At least 12 characters with upper and lower case letters, a number and a symbol.',
    confirmation: 'Repeat password',
    accept: 'Activate access',
    accepted: 'Access has been activated. You can now sign in.',
    invalid: 'This invitation is invalid, expired or has already been used.',
  },
  reset: {
    title: 'Reset password',
    subtitle: 'You will receive a single-use link if a matching account exists.',
    request: 'Request link',
    sent: 'If a matching account exists, an email has been sent.',
    complete: 'Save new password',
    completed: 'The password was changed and all previous sessions were ended.',
    invalid: 'The link is invalid, expired or has already been used.',
  },
  nav: {
    dashboard: 'Overview',
    documents: 'Documents',
    dunning: 'Reminders',
    files: 'Files',
    account: 'Account & security',
    team: 'Portal users',
    catalog: 'Catalog',
    cart: 'Cart',
    logout: 'Sign out',
  },
  dashboard: {
    title: 'Overview',
    subtitle: 'Recent transactions and open invoices at a glance.',
    openInvoices: 'Open invoices',
    recentDocuments: 'Recent documents',
    recentDunning: 'Recent reminders',
    showAll: 'Show all',
    error: 'The overview could not be loaded.',
  },
  documents: {
    title: 'Documents',
    subtitle: 'Quotes, orders, deliveries, invoices and credit notes.',
    search: 'Search documents',
    searchPlaceholder: 'Document number or reference …',
    typeFilter: 'Filter document type',
    allTypes: 'All document types',
    empty: 'No matching documents.',
    error: 'Documents could not be loaded.',
    details: 'Details',
    back: 'Back to documents',
    notFound: 'The document was not found or is not available.',
    preview: 'Open PDF',
    download: 'Download',
    downloadError: 'The file could not be downloaded.',
    date: 'Document date',
    due: 'Due',
    total: 'Total',
    open: 'Outstanding',
    net: 'Net',
    tax: 'Tax',
    billingAddress: 'Billing address',
    shippingAddress: 'Delivery address',
    positions: 'Line items',
    article: 'Item number',
    description: 'Description',
    quantity: 'Quantity',
    unitPrice: 'Unit price',
    flow: 'Document flow',
    customerData: 'Customer data for this document',
  },
  dunning: {
    title: 'Reminders',
    subtitle: 'Approved and sent reminders with their invoices.',
    level: 'Reminder level {{level}}',
    totalDue: 'Total due',
    principal: 'Open items',
    fees: 'Fees',
    interest: 'Interest',
    invoices: 'Included invoices',
    invoice: 'Invoice',
    empty: 'No reminders available.',
    error: 'Reminders could not be loaded.',
    notFound: 'The reminder was not found or is not available.',
    back: 'Back to reminders',
  },
  files: {
    title: 'Documents & files',
    subtitle: 'Files explicitly shared with you by the company.',
    attachments: 'Shared attachments',
    search: 'Search files',
    searchPlaceholder: 'File name or title …',
    empty: 'No shared files available.',
    error: 'Files could not be loaded.',
  },
  pagination: {
    label: 'Pagination',
    previous: 'Previous',
    next: 'Next',
    page: 'Page {{page}} of {{total}}',
  },
  sessions: {
    title: 'Active sessions',
    current: 'This device',
    revoke: 'End session',
    revokeAll: 'Sign out on all devices',
    empty: 'No active session found.',
    browser: 'Browser',
  },
  team: {
    title: 'Portal users',
    subtitle: 'Manage access for this customer.',
    invite: 'Invite user',
    contact: 'Contact',
    role: 'Portal role',
    users: 'Active access',
    invitations: 'Invitations',
    noUsers: 'No portal access yet.',
    noInvitations: 'No invitations yet.',
    twoFactor: 'Email 2FA',
    lastLogin: 'Last sign-in',
    activeSessions: 'Active sessions',
    active: 'Active',
    locked: 'Locked',
    enabled: 'Enabled',
    disabled: 'Disabled',
    pending: 'Pending',
    expired: 'Expired',
    accepted: 'Accepted',
    revoked: 'Revoked',
    lockReason: 'Locked by the customer administrator',
    revokeReason: 'Revoked by the customer administrator',
  },
  internal: {
    title: 'Customer portal',
    subtitle: 'Invitations, roles, locks and sessions for this customer.',
    required2fa: 'Require email 2FA for all portal users',
    invitationHours: 'Invitation validity (hours)',
    retentionDays: 'Portal activity retention (days)',
    access: 'Portal access',
    settings: 'Security & retention',
    noContacts: 'No available contact with an email address exists.',
    lockReason: 'Locked by an internal user',
    revokeReason: 'Revoked by an internal user',
    settingsHint: 'These settings apply to the customer portal throughout the tenant.',
  },
  activity: {
    title: 'Portal activity log',
    noEntries: 'No portal activity yet.',
    system: 'System',
    event: {
      LOGIN_SUCCESS: 'Successful sign-in',
      LOGIN_FAILED: 'Failed sign-in',
      LOGOUT: 'Sign-out',
      INVITATION_CREATED: 'Invitation created',
      INVITATION_RESENT: 'Invitation sent again',
      INVITATION_REVOKED: 'Invitation revoked',
      INVITATION_ACCEPTED: 'Invitation accepted',
      USER_LOCKED: 'Portal access locked',
      USER_UNLOCKED: 'Portal access unlocked',
      SESSION_REVOKED: 'Session ended',
      PASSWORD_RESET_REQUESTED: 'Password reset requested',
      PASSWORD_RESET_COMPLETED: 'Password changed',
      TWO_FACTOR_CHALLENGE: '2FA code requested',
      TWO_FACTOR_VERIFIED: '2FA verified',
      TWO_FACTOR_FAILED: '2FA failed',
      PROFILE_CHANGED: 'Profile changed',
      DOCUMENT_OPENED: 'Document opened',
      DOCUMENT_DOWNLOADED: 'Document downloaded',
      QUOTE_VIEWED: 'Quote viewed',
      ORDER_CREATED: 'Order created',
      ORDER_SUBMITTED: 'Order submitted',
      ACTION_FAILED: 'Portal action failed',
      ERROR_DISPLAYED: 'Error message displayed',
      DELIVERY_ADDRESS_CHANGED: 'Delivery address changed',
    },
  },
  role: { ADMIN: 'Administrator', PURCHASING: 'Purchasing', READ_ONLY: 'Read only' },
  actions: {
    invite: 'Send invitation',
    resend: 'Send again',
    revoke: 'Revoke',
    lock: 'Lock',
    unlock: 'Unlock',
    sessions: 'End all sessions',
    save: 'Save',
  },
  saved: 'Changes saved.',
  help: 'Customer portal help',
  backToLogin: 'Back to sign-in',
  select: 'Please select',
  unavailableContact: 'Already invited or activated',
  securityNotice: 'Credentials and single-use links are never written to logs.',
  error: 'The action could not be completed. Please try again.',
} as const;

export const portalTr = {
  ...portalOrdersTr,
  brand: 'Müşteri portalı',
  featureDisabled: {
    title: 'Alan kullanılamıyor',
    description: 'Bu portal alanı kuruluşunuz için şu anda devre dışıdır.',
  },
  welcome: 'Hoş geldiniz, {{name}}',
  accountSubtitle: '{{customer}} için güvenli erişiminiz.',
  login: {
    title: 'Müşteri portalında oturum açın',
    subtitle: 'Erişim yalnızca kişisel davetle sağlanır.',
    tenant: 'Kiracı',
    email: 'E-posta adresi',
    password: 'Parola',
    submit: 'Oturum aç',
    forgot: 'Parolanızı mı unuttunuz?',
    genericError: 'E-posta adresi veya parola yanlış.',
    twoFactor: 'Doğrulama kodu',
    codeSent: '{{email}} adresine bir kod gönderildi.',
    verify: 'Kodu doğrula',
  },
  invitation: {
    title: 'Portal erişimini etkinleştirin',
    subtitle: '{{customer}} tarafından {{contact}} için davet.',
    password: 'Parola belirle',
    passwordRules: 'Büyük ve küçük harf, sayı ve sembol içeren en az 12 karakter.',
    confirmation: 'Parolayı tekrarla',
    accept: 'Erişimi etkinleştir',
    accepted: 'Erişim etkinleştirildi. Artık oturum açabilirsiniz.',
    invalid: 'Bu davet geçersiz, süresi dolmuş veya daha önce kullanılmış.',
  },
  reset: {
    title: 'Parolayı sıfırla',
    subtitle: 'Eşleşen bir hesap varsa tek kullanımlık bağlantı alırsınız.',
    request: 'Bağlantı iste',
    sent: 'Eşleşen bir hesap varsa e-posta gönderildi.',
    complete: 'Yeni parolayı kaydet',
    completed: 'Parola değiştirildi ve önceki tüm oturumlar sonlandırıldı.',
    invalid: 'Bağlantı geçersiz, süresi dolmuş veya daha önce kullanılmış.',
  },
  nav: {
    dashboard: 'Genel bakış',
    documents: 'Belgeler',
    dunning: 'Hatırlatmalar',
    files: 'Dosyalar',
    account: 'Hesap ve güvenlik',
    team: 'Portal kullanıcıları',
    catalog: 'Katalog',
    cart: 'Sepet',
    logout: 'Oturumu kapat',
  },
  dashboard: {
    title: 'Genel bakış',
    subtitle: 'Güncel işlemler ve açık faturalar bir bakışta.',
    openInvoices: 'Açık faturalar',
    recentDocuments: 'Güncel belgeler',
    recentDunning: 'Güncel hatırlatmalar',
    showAll: 'Tümünü göster',
    error: 'Genel bakış yüklenemedi.',
  },
  documents: {
    title: 'Belgeler',
    subtitle: 'Teklifler, siparişler, teslimatlar, faturalar ve alacak dekontları.',
    search: 'Belgelerde ara',
    searchPlaceholder: 'Belge numarası veya referans …',
    typeFilter: 'Belge türünü filtrele',
    allTypes: 'Tüm belge türleri',
    empty: 'Eşleşen belge yok.',
    error: 'Belgeler yüklenemedi.',
    details: 'Ayrıntılar',
    back: 'Belgelere dön',
    notFound: 'Belge bulunamadı veya kullanıma açık değil.',
    preview: 'PDF’yi aç',
    download: 'İndir',
    downloadError: 'Dosya indirilemedi.',
    date: 'Belge tarihi',
    due: 'Vade',
    total: 'Toplam',
    open: 'Açık',
    net: 'Net',
    tax: 'Vergi',
    billingAddress: 'Fatura adresi',
    shippingAddress: 'Teslimat adresi',
    positions: 'Kalemler',
    article: 'Ürün numarası',
    description: 'Açıklama',
    quantity: 'Miktar',
    unitPrice: 'Birim fiyat',
    flow: 'Belge akışı',
    customerData: 'Belgeye ait müşteri bilgileri',
  },
  dunning: {
    title: 'Ödeme hatırlatmaları',
    subtitle: 'Onaylanan ve gönderilen hatırlatmalar ile ilgili faturalar.',
    level: 'Hatırlatma seviyesi {{level}}',
    totalDue: 'Toplam borç',
    principal: 'Açık kalemler',
    fees: 'Ücretler',
    interest: 'Faiz',
    invoices: 'İlgili faturalar',
    invoice: 'Fatura',
    empty: 'Hatırlatma yok.',
    error: 'Hatırlatmalar yüklenemedi.',
    notFound: 'Hatırlatma bulunamadı veya kullanıma açık değil.',
    back: 'Hatırlatmalara dön',
  },
  files: {
    title: 'Belgeler ve dosyalar',
    subtitle: 'Şirketin sizinle açıkça paylaştığı dosyalar.',
    attachments: 'Paylaşılan ekler',
    search: 'Dosyalarda ara',
    searchPlaceholder: 'Dosya adı veya başlık …',
    empty: 'Paylaşılan dosya yok.',
    error: 'Dosyalar yüklenemedi.',
  },
  pagination: {
    label: 'Sayfa gezintisi',
    previous: 'Önceki',
    next: 'Sonraki',
    page: 'Sayfa {{page}} / {{total}}',
  },
  sessions: {
    title: 'Etkin oturumlar',
    current: 'Bu cihaz',
    revoke: 'Oturumu sonlandır',
    revokeAll: 'Tüm cihazlarda oturumu kapat',
    empty: 'Etkin oturum bulunamadı.',
    browser: 'Tarayıcı',
  },
  team: {
    title: 'Portal kullanıcıları',
    subtitle: 'Bu müşterinin erişimlerini yönetin.',
    invite: 'Kullanıcı davet et',
    contact: 'İlgili kişi',
    role: 'Portal rolü',
    users: 'Etkin erişimler',
    invitations: 'Davetler',
    noUsers: 'Henüz portal erişimi yok.',
    noInvitations: 'Henüz davet yok.',
    twoFactor: 'E-posta 2FA',
    lastLogin: 'Son oturum',
    activeSessions: 'Etkin oturumlar',
    active: 'Etkin',
    locked: 'Engelli',
    enabled: 'Etkin',
    disabled: 'Devre dışı',
    pending: 'Bekliyor',
    expired: 'Süresi doldu',
    accepted: 'Kabul edildi',
    revoked: 'İptal edildi',
    lockReason: 'Müşteri yöneticisi tarafından engellendi',
    revokeReason: 'Müşteri yöneticisi tarafından iptal edildi',
  },
  internal: {
    title: 'Müşteri portalı',
    subtitle: 'Bu müşterinin davet, rol, engel ve oturumları.',
    required2fa: 'Tüm portal kullanıcıları için e-posta 2FA zorunlu',
    invitationHours: 'Davet geçerliliği (saat)',
    retentionDays: 'Portal etkinliği saklama süresi (gün)',
    access: 'Portal erişimleri',
    settings: 'Güvenlik ve saklama',
    noContacts: 'E-posta adresi olan uygun bir ilgili kişi yok.',
    lockReason: 'Dahili kullanıcı tarafından engellendi',
    revokeReason: 'Dahili kullanıcı tarafından iptal edildi',
    settingsHint: 'Bu ayarlar kiracı genelindeki müşteri portalı için geçerlidir.',
  },
  activity: {
    title: 'Portal etkinlik günlüğü',
    noEntries: 'Henüz portal etkinliği yok.',
    system: 'Sistem',
    event: {
      LOGIN_SUCCESS: 'Başarılı oturum açma',
      LOGIN_FAILED: 'Başarısız oturum açma',
      LOGOUT: 'Oturum kapatma',
      INVITATION_CREATED: 'Davet oluşturuldu',
      INVITATION_RESENT: 'Davet yeniden gönderildi',
      INVITATION_REVOKED: 'Davet iptal edildi',
      INVITATION_ACCEPTED: 'Davet kabul edildi',
      USER_LOCKED: 'Portal erişimi engellendi',
      USER_UNLOCKED: 'Portal erişim engeli kaldırıldı',
      SESSION_REVOKED: 'Oturum sonlandırıldı',
      PASSWORD_RESET_REQUESTED: 'Parola sıfırlama istendi',
      PASSWORD_RESET_COMPLETED: 'Parola değiştirildi',
      TWO_FACTOR_CHALLENGE: '2FA kodu istendi',
      TWO_FACTOR_VERIFIED: '2FA doğrulandı',
      TWO_FACTOR_FAILED: '2FA başarısız oldu',
      PROFILE_CHANGED: 'Profil değiştirildi',
      DOCUMENT_OPENED: 'Belge açıldı',
      DOCUMENT_DOWNLOADED: 'Belge indirildi',
      QUOTE_VIEWED: 'Teklif görüntülendi',
      ORDER_CREATED: 'Sipariş oluşturuldu',
      ORDER_SUBMITTED: 'Sipariş gönderildi',
      ACTION_FAILED: 'Portal işlemi başarısız',
      ERROR_DISPLAYED: 'Hata mesajı gösterildi',
      DELIVERY_ADDRESS_CHANGED: 'Teslimat adresi değiştirildi',
    },
  },
  role: { ADMIN: 'Yönetici', PURCHASING: 'Satın alma', READ_ONLY: 'Salt okunur' },
  actions: {
    invite: 'Davet gönder',
    resend: 'Yeniden gönder',
    revoke: 'İptal et',
    lock: 'Engelle',
    unlock: 'Engeli kaldır',
    sessions: 'Tüm oturumları sonlandır',
    save: 'Kaydet',
  },
  saved: 'Değişiklikler kaydedildi.',
  help: 'Müşteri portalı yardımı',
  backToLogin: 'Oturum açmaya dön',
  select: 'Lütfen seçin',
  unavailableContact: 'Zaten davet edilmiş veya etkin',
  securityNotice: 'Kimlik bilgileri ve tek kullanımlık bağlantılar asla günlüklere yazılmaz.',
  error: 'İşlem tamamlanamadı. Lütfen yeniden deneyin.',
} as const;

export const portalFr = {
  ...portalOrdersFr,
  brand: 'Portail client',
  featureDisabled: {
    title: 'Zone indisponible',
    description: 'Cette zone du portail est actuellement désactivée pour votre organisation.',
  },
  welcome: 'Bienvenue, {{name}}',
  accountSubtitle: 'Votre accès sécurisé à {{customer}}.',
  login: {
    title: 'Connexion au portail client',
    subtitle: 'L’accès est réservé aux personnes invitées.',
    tenant: 'Mandant',
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    submit: 'Se connecter',
    forgot: 'Mot de passe oublié ?',
    genericError: 'L’adresse e-mail ou le mot de passe est incorrect.',
    twoFactor: 'Code de vérification',
    codeSent: 'Un code a été envoyé à {{email}}.',
    verify: 'Vérifier le code',
  },
  invitation: {
    title: 'Activer l’accès au portail',
    subtitle: 'Invitation de {{customer}} pour {{contact}}.',
    password: 'Définir le mot de passe',
    passwordRules: 'Au moins 12 caractères avec majuscule, minuscule, chiffre et symbole.',
    confirmation: 'Répéter le mot de passe',
    accept: 'Activer l’accès',
    accepted: 'L’accès est activé. Vous pouvez maintenant vous connecter.',
    invalid: 'Cette invitation est invalide, expirée ou déjà utilisée.',
  },
  reset: {
    title: 'Réinitialiser le mot de passe',
    subtitle: 'Vous recevrez un lien à usage unique si un compte correspondant existe.',
    request: 'Demander le lien',
    sent: 'Si un compte correspondant existe, un e-mail a été envoyé.',
    complete: 'Enregistrer le nouveau mot de passe',
    completed: 'Le mot de passe a été modifié et toutes les anciennes sessions ont été fermées.',
    invalid: 'Le lien est invalide, expiré ou a déjà été utilisé.',
  },
  nav: {
    dashboard: 'Aperçu',
    documents: 'Documents',
    dunning: 'Relances',
    files: 'Fichiers',
    account: 'Compte et sécurité',
    team: 'Utilisateurs du portail',
    catalog: 'Catalogue',
    cart: 'Panier',
    logout: 'Se déconnecter',
  },
  dashboard: {
    title: 'Aperçu',
    subtitle: 'Opérations récentes et factures ouvertes en un coup d’œil.',
    openInvoices: 'Factures ouvertes',
    recentDocuments: 'Documents récents',
    recentDunning: 'Relances récentes',
    showAll: 'Tout afficher',
    error: 'Impossible de charger l’aperçu.',
  },
  documents: {
    title: 'Documents',
    subtitle: 'Devis, commandes, livraisons, factures et avoirs.',
    search: 'Rechercher des documents',
    searchPlaceholder: 'Numéro ou référence …',
    typeFilter: 'Filtrer le type',
    allTypes: 'Tous les types',
    empty: 'Aucun document correspondant.',
    error: 'Impossible de charger les documents.',
    details: 'Détails',
    back: 'Retour aux documents',
    notFound: 'Document introuvable ou non disponible.',
    preview: 'Ouvrir le PDF',
    download: 'Télécharger',
    downloadError: 'Impossible de télécharger le fichier.',
    date: 'Date du document',
    due: 'Échéance',
    total: 'Total',
    open: 'Solde',
    net: 'Net',
    tax: 'Taxe',
    billingAddress: 'Adresse de facturation',
    shippingAddress: 'Adresse de livraison',
    positions: 'Lignes',
    article: 'Référence article',
    description: 'Désignation',
    quantity: 'Quantité',
    unitPrice: 'Prix unitaire',
    flow: 'Flux documentaire',
    customerData: 'Données client du document',
  },
  dunning: {
    title: 'Relances',
    subtitle: 'Relances validées et envoyées avec leurs factures.',
    level: 'Niveau de relance {{level}}',
    totalDue: 'Total dû',
    principal: 'Postes ouverts',
    fees: 'Frais',
    interest: 'Intérêts',
    invoices: 'Factures incluses',
    invoice: 'Facture',
    empty: 'Aucune relance disponible.',
    error: 'Impossible de charger les relances.',
    notFound: 'Relance introuvable ou non disponible.',
    back: 'Retour aux relances',
  },
  files: {
    title: 'Documents et fichiers',
    subtitle: 'Fichiers explicitement partagés avec vous par l’entreprise.',
    attachments: 'Pièces jointes partagées',
    search: 'Rechercher des fichiers',
    searchPlaceholder: 'Nom ou titre du fichier …',
    empty: 'Aucun fichier partagé.',
    error: 'Impossible de charger les fichiers.',
  },
  pagination: {
    label: 'Pagination',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page {{page}} sur {{total}}',
  },
  sessions: {
    title: 'Sessions actives',
    current: 'Cet appareil',
    revoke: 'Fermer la session',
    revokeAll: 'Déconnecter tous les appareils',
    empty: 'Aucune session active.',
    browser: 'Navigateur',
  },
  team: {
    title: 'Utilisateurs du portail',
    subtitle: 'Gérer les accès de ce client.',
    invite: 'Inviter un utilisateur',
    contact: 'Contact',
    role: 'Rôle du portail',
    users: 'Accès actifs',
    invitations: 'Invitations',
    noUsers: 'Aucun accès au portail.',
    noInvitations: 'Aucune invitation.',
    twoFactor: '2FA par e-mail',
    lastLogin: 'Dernière connexion',
    activeSessions: 'Sessions actives',
    active: 'Actif',
    locked: 'Bloqué',
    enabled: 'Activée',
    disabled: 'Désactivée',
    pending: 'En attente',
    expired: 'Expirée',
    accepted: 'Acceptée',
    revoked: 'Révoquée',
    lockReason: 'Bloqué par l’administrateur client',
    revokeReason: 'Révoqué par l’administrateur client',
  },
  internal: {
    title: 'Portail client',
    subtitle: 'Invitations, rôles, blocages et sessions de ce client.',
    required2fa: 'Imposer la 2FA par e-mail à tous les utilisateurs',
    invitationHours: 'Validité de l’invitation (heures)',
    retentionDays: 'Conservation des activités du portail (jours)',
    access: 'Accès au portail',
    settings: 'Sécurité et conservation',
    noContacts: 'Aucun contact disponible ne possède d’adresse e-mail.',
    lockReason: 'Bloqué par un utilisateur interne',
    revokeReason: 'Révoqué par un utilisateur interne',
    settingsHint: 'Ces paramètres s’appliquent au portail client de tout le mandant.',
  },
  activity: {
    title: 'Journal d’activité du portail',
    noEntries: 'Aucune activité du portail.',
    system: 'Système',
    event: {
      LOGIN_SUCCESS: 'Connexion réussie',
      LOGIN_FAILED: 'Échec de connexion',
      LOGOUT: 'Déconnexion',
      INVITATION_CREATED: 'Invitation créée',
      INVITATION_RESENT: 'Invitation renvoyée',
      INVITATION_REVOKED: 'Invitation révoquée',
      INVITATION_ACCEPTED: 'Invitation acceptée',
      USER_LOCKED: 'Accès au portail bloqué',
      USER_UNLOCKED: 'Accès au portail débloqué',
      SESSION_REVOKED: 'Session fermée',
      PASSWORD_RESET_REQUESTED: 'Réinitialisation demandée',
      PASSWORD_RESET_COMPLETED: 'Mot de passe modifié',
      TWO_FACTOR_CHALLENGE: 'Code 2FA demandé',
      TWO_FACTOR_VERIFIED: '2FA confirmée',
      TWO_FACTOR_FAILED: 'Échec de la 2FA',
      PROFILE_CHANGED: 'Profil modifié',
      DOCUMENT_OPENED: 'Document ouvert',
      DOCUMENT_DOWNLOADED: 'Document téléchargé',
      QUOTE_VIEWED: 'Devis consulté',
      ORDER_CREATED: 'Commande créée',
      ORDER_SUBMITTED: 'Commande envoyée',
      ACTION_FAILED: 'Échec de l’action du portail',
      ERROR_DISPLAYED: 'Message d’erreur affiché',
      DELIVERY_ADDRESS_CHANGED: 'Adresse de livraison modifiée',
    },
  },
  role: { ADMIN: 'Administrateur', PURCHASING: 'Achats', READ_ONLY: 'Lecture seule' },
  actions: {
    invite: 'Envoyer l’invitation',
    resend: 'Renvoyer',
    revoke: 'Révoquer',
    lock: 'Bloquer',
    unlock: 'Débloquer',
    sessions: 'Fermer toutes les sessions',
    save: 'Enregistrer',
  },
  saved: 'Modifications enregistrées.',
  help: 'Aide du portail client',
  backToLogin: 'Retour à la connexion',
  select: 'Veuillez sélectionner',
  unavailableContact: 'Déjà invité ou activé',
  securityNotice:
    'Les identifiants et liens à usage unique ne sont jamais enregistrés dans les journaux.',
  error: 'L’action n’a pas pu être terminée. Veuillez réessayer.',
} as const;

export const portalEs = {
  ...portalOrdersEs,
  brand: 'Portal de clientes',
  featureDisabled: {
    title: 'Área no disponible',
    description: 'Esta área del portal está desactivada actualmente para su organización.',
  },
  welcome: 'Bienvenido, {{name}}',
  accountSubtitle: 'Su acceso seguro a {{customer}}.',
  login: {
    title: 'Acceder al portal de clientes',
    subtitle: 'El acceso solo está disponible mediante invitación personal.',
    tenant: 'Empresa',
    email: 'Correo electrónico',
    password: 'Contraseña',
    submit: 'Iniciar sesión',
    forgot: '¿Olvidó la contraseña?',
    genericError: 'El correo o la contraseña son incorrectos.',
    twoFactor: 'Código de verificación',
    codeSent: 'Se envió un código a {{email}}.',
    verify: 'Verificar código',
  },
  invitation: {
    title: 'Activar acceso al portal',
    subtitle: 'Invitación de {{customer}} para {{contact}}.',
    password: 'Definir contraseña',
    passwordRules: 'Al menos 12 caracteres con mayúscula, minúscula, número y símbolo.',
    confirmation: 'Repetir contraseña',
    accept: 'Activar acceso',
    accepted: 'El acceso se ha activado. Ya puede iniciar sesión.',
    invalid: 'La invitación no es válida, ha caducado o ya se utilizó.',
  },
  reset: {
    title: 'Restablecer contraseña',
    subtitle: 'Recibirá un enlace de un solo uso si existe una cuenta coincidente.',
    request: 'Solicitar enlace',
    sent: 'Si existe una cuenta coincidente, se ha enviado un correo.',
    complete: 'Guardar nueva contraseña',
    completed: 'La contraseña se cambió y se cerraron todas las sesiones anteriores.',
    invalid: 'El enlace no es válido, ha caducado o ya se utilizó.',
  },
  nav: {
    dashboard: 'Resumen',
    documents: 'Documentos',
    dunning: 'Avisos',
    files: 'Archivos',
    account: 'Cuenta y seguridad',
    team: 'Usuarios del portal',
    catalog: 'Catálogo',
    cart: 'Carrito',
    logout: 'Cerrar sesión',
  },
  dashboard: {
    title: 'Resumen',
    subtitle: 'Operaciones recientes y facturas abiertas de un vistazo.',
    openInvoices: 'Facturas abiertas',
    recentDocuments: 'Documentos recientes',
    recentDunning: 'Avisos recientes',
    showAll: 'Ver todos',
    error: 'No se pudo cargar el resumen.',
  },
  documents: {
    title: 'Documentos',
    subtitle: 'Ofertas, pedidos, entregas, facturas y abonos.',
    search: 'Buscar documentos',
    searchPlaceholder: 'Número o referencia …',
    typeFilter: 'Filtrar tipo',
    allTypes: 'Todos los tipos',
    empty: 'No hay documentos coincidentes.',
    error: 'No se pudieron cargar los documentos.',
    details: 'Detalles',
    back: 'Volver a documentos',
    notFound: 'El documento no existe o no está disponible.',
    preview: 'Abrir PDF',
    download: 'Descargar',
    downloadError: 'No se pudo descargar el archivo.',
    date: 'Fecha del documento',
    due: 'Vencimiento',
    total: 'Total',
    open: 'Pendiente',
    net: 'Neto',
    tax: 'Impuesto',
    billingAddress: 'Dirección de facturación',
    shippingAddress: 'Dirección de entrega',
    positions: 'Líneas',
    article: 'Número de artículo',
    description: 'Descripción',
    quantity: 'Cantidad',
    unitPrice: 'Precio unitario',
    flow: 'Flujo documental',
    customerData: 'Datos del cliente del documento',
  },
  dunning: {
    title: 'Avisos de pago',
    subtitle: 'Avisos aprobados y enviados con sus facturas.',
    level: 'Nivel de aviso {{level}}',
    totalDue: 'Total pendiente',
    principal: 'Partidas abiertas',
    fees: 'Gastos',
    interest: 'Intereses',
    invoices: 'Facturas incluidas',
    invoice: 'Factura',
    empty: 'No hay avisos.',
    error: 'No se pudieron cargar los avisos.',
    notFound: 'El aviso no existe o no está disponible.',
    back: 'Volver a avisos',
  },
  files: {
    title: 'Documentos y archivos',
    subtitle: 'Archivos que la empresa ha compartido expresamente contigo.',
    attachments: 'Adjuntos compartidos',
    search: 'Buscar archivos',
    searchPlaceholder: 'Nombre o título …',
    empty: 'No hay archivos compartidos.',
    error: 'No se pudieron cargar los archivos.',
  },
  pagination: {
    label: 'Paginación',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página {{page}} de {{total}}',
  },
  sessions: {
    title: 'Sesiones activas',
    current: 'Este dispositivo',
    revoke: 'Cerrar sesión',
    revokeAll: 'Cerrar sesión en todos los dispositivos',
    empty: 'No hay sesiones activas.',
    browser: 'Navegador',
  },
  team: {
    title: 'Usuarios del portal',
    subtitle: 'Gestione el acceso de este cliente.',
    invite: 'Invitar usuario',
    contact: 'Contacto',
    role: 'Rol del portal',
    users: 'Accesos activos',
    invitations: 'Invitaciones',
    noUsers: 'Aún no hay accesos.',
    noInvitations: 'Aún no hay invitaciones.',
    twoFactor: '2FA por correo',
    lastLogin: 'Último acceso',
    activeSessions: 'Sesiones activas',
    active: 'Activo',
    locked: 'Bloqueado',
    enabled: 'Activada',
    disabled: 'Desactivada',
    pending: 'Pendiente',
    expired: 'Caducada',
    accepted: 'Aceptada',
    revoked: 'Revocada',
    lockReason: 'Bloqueado por el administrador del cliente',
    revokeReason: 'Revocado por el administrador del cliente',
  },
  internal: {
    title: 'Portal de clientes',
    subtitle: 'Invitaciones, roles, bloqueos y sesiones de este cliente.',
    required2fa: 'Exigir 2FA por correo a todos los usuarios',
    invitationHours: 'Validez de invitación (horas)',
    retentionDays: 'Conservación de actividad del portal (días)',
    access: 'Accesos al portal',
    settings: 'Seguridad y conservación',
    noContacts: 'No hay ningún contacto disponible con correo electrónico.',
    lockReason: 'Bloqueado por un usuario interno',
    revokeReason: 'Revocado por un usuario interno',
    settingsHint: 'Estos ajustes se aplican al portal de clientes de toda la empresa.',
  },
  activity: {
    title: 'Registro de actividad del portal',
    noEntries: 'Aún no hay actividad del portal.',
    system: 'Sistema',
    event: {
      LOGIN_SUCCESS: 'Acceso correcto',
      LOGIN_FAILED: 'Acceso fallido',
      LOGOUT: 'Cierre de sesión',
      INVITATION_CREATED: 'Invitación creada',
      INVITATION_RESENT: 'Invitación reenviada',
      INVITATION_REVOKED: 'Invitación revocada',
      INVITATION_ACCEPTED: 'Invitación aceptada',
      USER_LOCKED: 'Acceso al portal bloqueado',
      USER_UNLOCKED: 'Acceso al portal desbloqueado',
      SESSION_REVOKED: 'Sesión cerrada',
      PASSWORD_RESET_REQUESTED: 'Restablecimiento solicitado',
      PASSWORD_RESET_COMPLETED: 'Contraseña cambiada',
      TWO_FACTOR_CHALLENGE: 'Código 2FA solicitado',
      TWO_FACTOR_VERIFIED: '2FA verificada',
      TWO_FACTOR_FAILED: 'Error de 2FA',
      PROFILE_CHANGED: 'Perfil cambiado',
      DOCUMENT_OPENED: 'Documento abierto',
      DOCUMENT_DOWNLOADED: 'Documento descargado',
      QUOTE_VIEWED: 'Oferta consultada',
      ORDER_CREATED: 'Pedido creado',
      ORDER_SUBMITTED: 'Pedido enviado',
      ACTION_FAILED: 'Acción del portal fallida',
      ERROR_DISPLAYED: 'Mensaje de error mostrado',
      DELIVERY_ADDRESS_CHANGED: 'Dirección de entrega cambiada',
    },
  },
  role: { ADMIN: 'Administrador', PURCHASING: 'Compras', READ_ONLY: 'Solo lectura' },
  actions: {
    invite: 'Enviar invitación',
    resend: 'Reenviar',
    revoke: 'Revocar',
    lock: 'Bloquear',
    unlock: 'Desbloquear',
    sessions: 'Cerrar todas las sesiones',
    save: 'Guardar',
  },
  saved: 'Cambios guardados.',
  help: 'Ayuda del portal de clientes',
  backToLogin: 'Volver al acceso',
  select: 'Seleccione',
  unavailableContact: 'Ya invitado o activado',
  securityNotice: 'Las credenciales y los enlaces de un solo uso nunca se guardan en registros.',
  error: 'No se pudo completar la acción. Inténtelo de nuevo.',
} as const;

export const portalRu = {
  ...portalOrdersRu,
  brand: 'Клиентский портал',
  welcome: 'Добро пожаловать, {{name}}',
  accountSubtitle: 'Безопасный доступ к {{customer}}.',
  login: {
    title: 'Вход на клиентский портал',
    subtitle: 'Доступ предоставляется только по личному приглашению.',
    tenant: 'Организация',
    email: 'Электронная почта',
    password: 'Пароль',
    submit: 'Войти',
    forgot: 'Забыли пароль?',
    genericError: 'Неверный адрес электронной почты или пароль.',
    twoFactor: 'Код подтверждения',
    codeSent: 'Код отправлен на {{email}}.',
    verify: 'Подтвердить код',
  },
  invitation: {
    title: 'Активация доступа',
    subtitle: 'Приглашение от {{customer}} для {{contact}}.',
    password: 'Задать пароль',
    passwordRules: 'Не менее 12 символов: прописная и строчная буквы, цифра и специальный символ.',
    confirmation: 'Повторить пароль',
    accept: 'Активировать доступ',
    accepted: 'Доступ активирован. Теперь можно войти.',
    invalid: 'Приглашение недействительно, истекло или уже использовано.',
  },
  reset: {
    title: 'Сброс пароля',
    subtitle: 'Если учётная запись существует, вы получите одноразовую ссылку.',
    request: 'Запросить ссылку',
    sent: 'Если учётная запись существует, письмо отправлено.',
    complete: 'Сохранить новый пароль',
    completed: 'Пароль изменён, все предыдущие сеансы завершены.',
    invalid: 'Ссылка недействительна, истекла или уже использована.',
  },
  nav: {
    dashboard: 'Обзор',
    documents: 'Документы',
    dunning: 'Напоминания',
    files: 'Файлы',
    account: 'Учётная запись и безопасность',
    team: 'Пользователи портала',
    catalog: 'Каталог',
    cart: 'Корзина',
    logout: 'Выйти',
  },
  dashboard: {
    title: 'Обзор',
    subtitle: 'Последние операции и открытые счета на одной странице.',
    openInvoices: 'Открытые счета',
    recentDocuments: 'Последние документы',
    recentDunning: 'Последние напоминания',
    showAll: 'Показать все',
    error: 'Не удалось загрузить обзор.',
  },
  documents: {
    title: 'Документы',
    subtitle: 'Предложения, заказы, поставки, счета и кредит-ноты.',
    search: 'Поиск документов',
    searchPlaceholder: 'Номер или ссылка …',
    typeFilter: 'Фильтр типа',
    allTypes: 'Все типы',
    empty: 'Подходящих документов нет.',
    error: 'Не удалось загрузить документы.',
    details: 'Подробнее',
    back: 'Назад к документам',
    notFound: 'Документ не найден или недоступен.',
    preview: 'Открыть PDF',
    download: 'Скачать',
    downloadError: 'Не удалось скачать файл.',
    date: 'Дата документа',
    due: 'Срок оплаты',
    total: 'Итого',
    open: 'Остаток',
    net: 'Нетто',
    tax: 'Налог',
    billingAddress: 'Адрес для счетов',
    shippingAddress: 'Адрес доставки',
    positions: 'Позиции',
    article: 'Артикул',
    description: 'Наименование',
    quantity: 'Количество',
    unitPrice: 'Цена за единицу',
    flow: 'Цепочка документов',
    customerData: 'Данные клиента для документа',
  },
  dunning: {
    title: 'Напоминания',
    subtitle: 'Утверждённые и отправленные напоминания со счетами.',
    level: 'Уровень {{level}}',
    totalDue: 'Общая сумма',
    principal: 'Открытые позиции',
    fees: 'Сборы',
    interest: 'Проценты',
    invoices: 'Включённые счета',
    invoice: 'Счёт',
    empty: 'Напоминаний нет.',
    error: 'Не удалось загрузить напоминания.',
    notFound: 'Напоминание не найдено или недоступно.',
    back: 'Назад к напоминаниям',
  },
  files: {
    title: 'Документы и файлы',
    subtitle: 'Файлы, явно предоставленные вам компанией.',
    attachments: 'Доступные вложения',
    search: 'Поиск файлов',
    searchPlaceholder: 'Имя файла или заголовок …',
    empty: 'Доступных файлов нет.',
    error: 'Не удалось загрузить файлы.',
  },
  pagination: {
    label: 'Навигация по страницам',
    previous: 'Назад',
    next: 'Далее',
    page: 'Страница {{page}} из {{total}}',
  },
  sessions: {
    title: 'Активные сеансы',
    current: 'Это устройство',
    revoke: 'Завершить сеанс',
    revokeAll: 'Выйти на всех устройствах',
    empty: 'Активных сеансов нет.',
    browser: 'Браузер',
  },
  team: {
    title: 'Пользователи портала',
    subtitle: 'Управление доступом этого клиента.',
    invite: 'Пригласить пользователя',
    contact: 'Контакт',
    role: 'Роль портала',
    users: 'Активные доступы',
    invitations: 'Приглашения',
    noUsers: 'Доступов пока нет.',
    noInvitations: 'Приглашений пока нет.',
    twoFactor: '2FA по почте',
    lastLogin: 'Последний вход',
    activeSessions: 'Активные сеансы',
    active: 'Активен',
    locked: 'Заблокирован',
    enabled: 'Включена',
    disabled: 'Отключена',
    pending: 'Ожидает',
    expired: 'Истекло',
    accepted: 'Принято',
    revoked: 'Отозвано',
    lockReason: 'Заблокирован администратором клиента',
    revokeReason: 'Отозван администратором клиента',
  },
  internal: {
    title: 'Клиентский портал',
    subtitle: 'Приглашения, роли, блокировки и сеансы клиента.',
    required2fa: 'Требовать 2FA по почте для всех пользователей',
    invitationHours: 'Срок приглашения (часы)',
    retentionDays: 'Хранение активности портала (дни)',
    access: 'Доступы к порталу',
    settings: 'Безопасность и хранение',
    noContacts: 'Нет доступного контакта с адресом электронной почты.',
    lockReason: 'Заблокирован внутренним пользователем',
    revokeReason: 'Отозван внутренним пользователем',
    settingsHint: 'Эти настройки действуют для клиентского портала всего арендатора.',
  },
  activity: {
    title: 'Журнал активности портала',
    noEntries: 'Активности портала пока нет.',
    system: 'Система',
    event: {
      LOGIN_SUCCESS: 'Успешный вход',
      LOGIN_FAILED: 'Неудачный вход',
      LOGOUT: 'Выход',
      INVITATION_CREATED: 'Приглашение создано',
      INVITATION_RESENT: 'Приглашение отправлено повторно',
      INVITATION_REVOKED: 'Приглашение отозвано',
      INVITATION_ACCEPTED: 'Приглашение принято',
      USER_LOCKED: 'Доступ к порталу заблокирован',
      USER_UNLOCKED: 'Доступ к порталу разблокирован',
      SESSION_REVOKED: 'Сеанс завершён',
      PASSWORD_RESET_REQUESTED: 'Запрошен сброс пароля',
      PASSWORD_RESET_COMPLETED: 'Пароль изменён',
      TWO_FACTOR_CHALLENGE: 'Запрошен код 2FA',
      TWO_FACTOR_VERIFIED: '2FA подтверждена',
      TWO_FACTOR_FAILED: 'Ошибка 2FA',
      PROFILE_CHANGED: 'Профиль изменён',
      DOCUMENT_OPENED: 'Документ открыт',
      DOCUMENT_DOWNLOADED: 'Документ скачан',
      QUOTE_VIEWED: 'Предложение просмотрено',
      ORDER_CREATED: 'Заказ создан',
      ORDER_SUBMITTED: 'Заказ отправлен',
      ACTION_FAILED: 'Ошибка действия портала',
      ERROR_DISPLAYED: 'Показано сообщение об ошибке',
      DELIVERY_ADDRESS_CHANGED: 'Адрес доставки изменён',
    },
  },
  role: { ADMIN: 'Администратор', PURCHASING: 'Закупки', READ_ONLY: 'Только чтение' },
  actions: {
    invite: 'Отправить приглашение',
    resend: 'Отправить снова',
    revoke: 'Отозвать',
    lock: 'Заблокировать',
    unlock: 'Разблокировать',
    sessions: 'Завершить все сеансы',
    save: 'Сохранить',
  },
  saved: 'Изменения сохранены.',
  help: 'Справка клиентского портала',
  backToLogin: 'Вернуться ко входу',
  select: 'Выберите',
  unavailableContact: 'Уже приглашён или активирован',
  securityNotice: 'Учётные данные и одноразовые ссылки никогда не записываются в журналы.',
  error: 'Не удалось выполнить действие. Повторите попытку.',
} as const;
